import React from "react";

import { getDate, getDateDiffInDays, getDateDiffString } from "../../../../common/DateUtils";
import { getDocument } from "../../../../container/Feed/Feed";
import reminderDotImage from "../../../../assets/icons/activity-dot.svg";

// Styles
import "./Reminder.scss";

const Reminder = ({ reminder, handleDocumentView, ...props }) => {
  return (
    <div className="reminder">
      <div className="reminder-title-section">
        <img className="reminder-title-section-dot-image" src={reminderDotImage} alt="Mark read" />
        <div>
          {reminder.dateTitle} of
          <span
            className="reminder-title-section-action"
            onClick={async () => {
              const document = await getDocument(reminder.documentId);
              handleDocumentView(document);
            }}
          >
            {reminder.documentTitle}
          </span>
        </div>
      </div>
      <div className="reminder-datetime-section">
        <div
          className={`reminder-datetime-section-countdown  ${
            getDateDiffInDays(reminder.documentDate) === 0 ? "date-today" : ""
          }`}
        >
          {getDateDiffString(reminder.documentDate)}
        </div>
        <div className="reminder-datetime-section-date">{getDate(reminder.documentDate, "mmm d")}</div>
      </div>
    </div>
  );
};

export default Reminder;
